import React from 'react';
import { Checkboard } from 'react-color/lib/components/common';
import { RGBColor } from 'react-color';
import {
    ColorCircle,
    EmptyColorCircle,
    SelectedColorCircle
} from './HBColorPicker.styles';

export interface Props {
    color: RGBColor | string;
    alpha: number;
    onClick?: () => void;
    isSelected?: boolean;
    testId?: string;
    isSquare?: boolean;
}

const ColorCircleBlock = ({
    color,
    alpha,
    onClick,
    isSelected,
    isSquare = false,
    testId
}: Props) => {
    const ColorSwatch = (
        <ColorCircle
            isSquare={isSquare}
            backgroundColor={color}
            onClick={onClick}
            data-testid={testId}
        >
            {alpha < 1 && alpha !== 0 && <Checkboard />}
            {alpha === 0 && <EmptyColorCircle />}
        </ColorCircle>
    );

    if (isSquare) {
        return <>{ColorSwatch}</>;
    }

    return (
        <SelectedColorCircle isSelected={isSelected}>
            {ColorSwatch}
        </SelectedColorCircle>
    );
};

export default ColorCircleBlock;
